import {
  APPROVAL_GROUP_CSV_TEMPLATE_URL,
  APPROVAL_GROUP_WITH_ADVANCED_TRIGGERS_CSV_TEMPLATE_URL,
  IMPORT_APPROVAL_ROUTING_GROUP_URL,
} from '@webapp/api/ImportAPI'
import messages from '@webapp/containers/SettingsImport/messages'
import { type SettingsImportSectionData } from '@webapp/containers/SettingsImport/types'
import { ImportTypes } from '@webapp/models/enums'

const FIELD_NAME_MAPPER_MINIMAL = {
  group_name: 'Group Name',
  type: 'Type',
  location: 'Location',
  department: 'Department',
  sequence: 'Sequence',
  action_on_duplicate: 'Action On Duplicate',
  non_field_errors: 'Not Applicable',
  is_pooled: 'Approval Pools',
}
const REQUIRED_FIELDS_MINIMAL = ['group_name', 'type', 'location', 'department']
const OPTIONAL_FIELDS = ['sequence', 'action_on_duplicate', 'is_pooled']
const HELP_DESK_ARTICLE_URL =
  'https://success.procurify.com/en/articles/9001887'

export const SETTINGS_IMPORT_APPROVAL_ROUTING_GROUP_SECTION_DATA: SettingsImportSectionData =
  {
    type: ImportTypes.APPROVAL_ROUTING_GROUP,
    title: messages.approvalRoutingGroupHeader,
    description: {
      message: messages.approvalRoutingGroupDescription,
    },
    href: HELP_DESK_ARTICLE_URL,
    modalTitle: messages.approvalRoutingGroupModalHeader,
    importerOptions: {
      importEndpoint: IMPORT_APPROVAL_ROUTING_GROUP_URL,
      templateEndpoint: APPROVAL_GROUP_CSV_TEMPLATE_URL,
      requiredFields: REQUIRED_FIELDS_MINIMAL,
      optionalFields: OPTIONAL_FIELDS,
      fieldNameMapper: FIELD_NAME_MAPPER_MINIMAL,
    },
  }

export const SETTINGS_IMPORT_APPROVAL_ROUTING_GROUP_WITH_ADVANCED_TRIGGERS: SettingsImportSectionData =
  {
    type: ImportTypes.APPROVAL_ROUTING_GROUP,
    title: messages.approvalRoutingGroupHeader,
    description: {
      message: messages.approvalRoutingGroupDescription,
    },
    href: HELP_DESK_ARTICLE_URL,
    modalTitle: messages.approvalRoutingGroupModalHeader,
    importerOptions: {
      importEndpoint: IMPORT_APPROVAL_ROUTING_GROUP_URL,
      templateEndpoint: APPROVAL_GROUP_WITH_ADVANCED_TRIGGERS_CSV_TEMPLATE_URL,
      requiredFields: [...REQUIRED_FIELDS_MINIMAL, 'account_code'],
      optionalFields: OPTIONAL_FIELDS,
      fieldNameMapper: {
        ...FIELD_NAME_MAPPER_MINIMAL,
        account_code: 'Account Code',
      },
    },
  }
